/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { BsFillQuestionCircleFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../../../../../app/dialog/dialog.actions';

export const Support: FunctionComponent = () => {
  const dispatch = useDispatch();

  const handleOpenSupportDialog = useCallback(() => {
    dispatch(openDialog('supportDialog'));
  }, [dispatch]);

  return (
    <li>
      <a style={{ cursor: 'pointer' }} className="panel-button" onClick={handleOpenSupportDialog}>
        <BsFillQuestionCircleFill size={19} />
      </a>
    </li>
  );
};
